import React, { Component } from 'react'
import { List, Stepper, Toast } from 'antd-mobile'
import { connect } from 'react-redux'
import { setHeader } from '@/util/set-header'
import { fetchPayBase } from '@/api/payment'
import SelectPay from './../common/select-pay/select-pay'
import PayGroup from './../common/pay-group'

const { Item } = List
const AStepper: any = Stepper
const mapStateToProps = (state: any) => {
  return {
    info: state.payment,
  }
}

@(connect(mapStateToProps) as any)
export default class Bed extends Component<any, any> {
  state: any = {
    data: {
      roomfee: {},
      info: {},
    },
    amount: 1,
  }

  params = {
    pay_type: 'alipay',
    money: '',
  }
  constructor(props: any) {
    super(props)
    this.initData = this.initData.bind(this)
  }
  async componentDidMount() {
    setHeader({ title: '缴费', leftClick: this.closePage.bind(this) })
    Toast.loading('加载中', 0)
    const { info } = this.props
    if (info.checkin_id) {
      this.initData(info)
    }
  }

  // 关闭当前缴费页
  closePage() {
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
  }

  async componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.info
    const { info } = this.props
    if (nextInfo.checkin_id === '') {
      Toast.info('您当前可能还未入住，请入住后在缴费哦~', 2, () => {
        if (window.WebViewBridge) {
          window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
        } else if (window.webkit) {
          window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
      })
      return
    }
    if (info.checkin_id !== nextInfo.checkin_id) {
      this.initData(nextInfo)
    }
  }
  async initData(info: any) {
    const { data } = await fetchPayBase(info.checkin_id)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
          window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
        } else if (window.webkit) {
          window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
      })
      return
    }
    this.setState({ data: data.data, loading: false })
  }
  get total() {
    const { amount } = this.state
    const { info } = this.state.data
    if (info.cycle_price) {
      return parseFloat(info.cycle_price) * amount
    }
    return ''
  }

  loadData = () => {
    const { data, amount } = this.state
    const { roomfee, info } = data
    const { subject_id, subject_name } = roomfee
    return {
      pay_type: this.params.pay_type,
      cost_data: [
        {
          money: this.total,
          subject_id,
          subject_name,
          type: info.bill_cycle_type,
          cycle: amount,
        },
      ],
    }
  }
  _handleBlur() {
    window.scroll(0, 0);
  }

  _stepperChange(amount: any) {
    let step =  parseInt(amount)    
    if (isNaN(step)) {
      this.setState({amount: 1})
    } else {
      this.setState({ amount: step })
    }
  }
  
  render() {
    const { name } = this.props.info
    const { roomfee, info } = this.state.data
    const { amount } = this.state
    const { total } = this
    return (
      <div className="pay-form">
        <List>
          <Item>
            <span className="label">缴费人</span>
            <span className="value">{name}</span>
          </Item>
          <Item>
            <span className="label">房间号</span>
            <span className="value">{`${info.store_no || ''}-${info.room_no ||
              ''}-${info.bed_no || ''}`}</span>
          </Item>
        </List>
        <div className="line" />
        <List>
          <Item>
            <span className="label">缴费项目</span>
            <span className="value subject-name">{roomfee.subject_name}</span>
          </Item>
          <Item>
            <span className="label">结算周期</span>
            <span className="value">{info.cycle_type}</span>
          </Item>
          <Item>
            <span className="label">周期单价</span>
            <span className="value">
              {info.cycle_price && parseFloat(info.cycle_price).toFixed(2)}
            </span>
          </Item>
          <Item
            extra={
              <AStepper
                min={1}
                style={{ width: '100%', minWidth: '1rem' }}
                showNumber
                size="small"
                defaultValue={1}
                value={amount}
                onChange={(amount: any) => this._stepperChange(amount)}
                onBlur={this._handleBlur}
              />
            }
          >
            缴费周期
          </Item>
          <SelectPay onChange={type => (this.params.pay_type = type)} />
        </List>
        <PayGroup money={total} loadData={this.loadData} />
      </div>
    )
  }
}
